export default class ImageApi {
    constructor(config) {
        this.config = config
    }

    /**
     * Conditionally builds a custom url for server-side resizing
     * @param {Object} args
     * @param {String} args.src
     * @param {String} args.width
     * @param {String} args.height
     * @return {Object}
     */
    getImageUrl({ src, width, height }) {
        if (!this.config.enableImageResizing) return { src }
        // TODO To be completed

        return { src }
    }
}
